
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/rebates-for-our-ev-partners",
      function () {
        return require("private-next-pages/evcharging/rebates-for-our-ev-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/rebates-for-our-ev-partners"])
      });
    }
  